var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.componentList),function(cmp){return _c('div',{key:cmp.url,staticClass:"tour-360",class:{
      'tour-360--autoplay': cmp.name === 'Matterport' && _vm.isAutoplay(cmp.url) && _vm.isMobile() && !_vm.isTop
    }},[_c(cmp.name,{tag:"component",attrs:{"url":cmp.url}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }